/** @jsxImportSource @emotion/react */
import { PanelCard } from '../../../design-system/molecules/PanelCard/PanelCard';
import { Table } from '../../../design-system/molecules/Table/Table';
import { Badge } from '../../../design-system/atoms/Badge/Badge';
import type { JobRow } from '../../types';
import { jobStatusTone } from '../../types';
import { rowStyle, mutedStyle } from './JobTable.styles';

export interface JobTableProps {
  jobs: JobRow[];
  onOpenJob: (id: number) => void;
}

/** 글/댓글 수 표기. 결과 없으면 "—". */
function countLabel(job: JobRow) {
  if (job.posts === null || job.comments === null) return '—';
  return `${job.posts} / ${job.comments.toLocaleString()}`;
}

/** 생성시각 ISO → 로컬 "YYYY-MM-DD HH:mm". 파싱 실패 시 원본 반환. */
function formatCreated(iso: string) {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

/** 수집 이력 표. Job 목록과 상세 진입에 활용. */
export function JobTable({ jobs, onOpenJob }: JobTableProps) {
  return (
    <PanelCard flush>
      <Table headers={['id', '모듈', '트리거', '수집기', '상태', '글/댓글', '소요', '생성시각']}>
        {jobs.map((job) => (
          <tr key={job.id} css={rowStyle} onClick={() => onOpenJob(job.id)}>
            <td>{job.id}</td>
            <td>{job.module}</td>
            <td>{job.trigger}</td>
            <td>{job.collector}</td>
            <td>
              <Badge tone={jobStatusTone(job.status)}>{job.status}</Badge>
            </td>
            <td css={job.posts === null ? mutedStyle : undefined}>{countLabel(job)}</td>
            <td css={mutedStyle}>{job.durationLabel}</td>
            <td css={mutedStyle}>{formatCreated(job.created)}</td>
          </tr>
        ))}
      </Table>
    </PanelCard>
  );
}
